import { API_URL_AWARD } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";
import TCreateEditAward from "types/Award/createEditAward";

const createAward = (newAward: TCreateEditAward) =>
  apiInstance({
    url: API_URL_AWARD,
    method: "post",
    data: newAward,
  });

export default createAward;
